import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
  import { useStore } from 'vuex';
  import { vibrate } from '../utils/vibrate';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrackList',
  setup(__props, { expose }) {
  expose();

  const store = useStore();
  
  const trackList = ref(null);
  
  const getCurrTrack = (): number => {
    return store.getters.currentTrack;
  };
  
  const updateCurrTrack = (newCurrTrack: number): void => {
    store.commit('refreshCurrentTrack', newCurrTrack);
    
  }
  
  store.subscribe((mutation, state) => {
    if (mutation.type === 'refreshTrackListInfo') {
      vibrate([100, 100, 100]);
      trackList.value = store.getters.trackListInfo;
    }
  });
  

const __returned__ = { store, trackList, getCurrTrack, updateCurrTrack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})